import { useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import ModalWindow from "components/ModalWindow";
import { makeStyles, Typography, FormControl, MenuItem } from "@material-ui/core";
import { Stack } from "@mui/material";
import ViewsActions from "actions/ViewsActions";
import { getCachedData } from "api/Cache";
import FieldInputSelect2 from "components/FieldInputSelect2";
import { CustomSelect2 } from "components";
import { StorageUtils } from "services/UtilsService";
import {CommonDialogBox} from "components";
import { Button, TextField } from "@mui/material";
import { tss } from "tss-react";
import { useSelector } from 'react-redux';

const hoverColor = "#02578E";

/*const useStyles = makeStyles({
    paper: {
        width: 450,
        minHeight: 420,
        borderRadius: 12,
        padding: "15px 22px",
        border: "none",
    },
    title: {
        fontSize: 25,
        fontWeight: 600,
        paddingBottom: "15px"
    },
    row: {
        position: "relative",
        width: "100%",
        minHeight: 75,
        padding: "7px 0px 13px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "&.textarea": {
            minHeight: "180px"
        },
        "& textarea": {
            height: "40px"
        },
        "&.buttons": {
            flexDirection: "row",
            justifyContent: "end",
            paddingTop: 20
        }
    },
    header: {
        fontSize: 12,
        color: "rgba(0,0,0,0.55)",
    },
    margin: {
        marginTop: -5,
    },
    label: {
        paddingBottom: 15,
        fontWeight: 600,
        color: "#414141",
        fontSize: 15
    },
    formControl: {
        margin: 1,
        minWidth: 120,
    },
    button: {
        minWidth: 20,
        padding: "5px 15px",
        marginLeft: 5,
        width: 90,
        height: 39,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
    select: {
        width: 380,
        height: "45px"
    },
    inputField: {
        "& .MuiOutlinedInput-root": {
            color: "#000",
            height: 45,
            backgroundColor: "rgba(32,32,32,.03)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(32,32,32,.25)",
                borderWidth: "1px",
            },
            "&.Mui-focused": {
                backgroundColor: "#fff",
                "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: hoverColor,
                        borderWidth: "1px",
                        color: "#000"
                },
            },
            "& .MuiInputLabel-outlined": {
                color: "#2e2e2e",
                fontWeight: "bold",
                "&.Mui-focused": {
                    color: "hoverColor",
                },
            },
        },
    }
});*/
const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 20,
    },
    header: {
        fontSize: 12,
        color: "rgba(0,0,0,0.55)",
    },
    margin: {
        marginTop: -5,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
    textField: {
        width: 300,
    },
    m24: {
        margin: '2.4rem'
    },
    rounded8: {
        borderRadius: '.8rem'
    },
    whitebg: {
        backgroundColor: '#fff'
    },
    gap12: {
        gridGap: '1.2rem',
        gap: '1.2rem'
    },
    row: {
        
    },
    select: {
        width: 380,
        height: "45px"
    },
    inputField: {
        "& .MuiOutlinedInput-root": {
            color: "#000",
            height: 45,
            backgroundColor: "rgba(32,32,32,.03)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(32,32,32,.25)",
                borderWidth: "1px",
            },
            "&.Mui-focused": {
                backgroundColor: "#fff",
                "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: hoverColor,
                        borderWidth: "1px",
                        color: "#000"
                },
            },
            "& .MuiInputLabel-outlined": {
                color: "#2e2e2e",
                fontWeight: "bold",
                "&.Mui-focused": {
                    color: "hoverColor",
                },
            },
        },
    }
}));

type IProps = {
    handleClose: () => void;
    folderId?: string;
    projectId?: string;
};

export default function AddViewPanel(props: IProps) {
    const { classes } = useStyles();
    const history = useHistory();
    const projects = getCachedData("projects");
    const projectsRef = getCachedData("projectsRef");
    const fullAccessProjects: any = [];
    const { folderId, projectId } = props;
    const storeAuthData = useSelector((state: any) => state.auth);
    const { defaultProjects } = storeAuthData;

    Object.values(projectsRef).forEach((project: any) => {
        (project.access_level === "full" && !defaultProjects.includes(project.ID)) &&
            fullAccessProjects.push(project["project_ref"]);
    });
    const currentProjects = Object.values(projects).filter((project: any) =>
        fullAccessProjects.includes(project["ID"])
    );
    const filter = projectId ? projectId : StorageUtils.loadFromSessionStorage("filter") || "all";
    const [error, setError] = useState("");
    const [values, setValues] = useState({
        name: "",
        description: "",
        projectId: projectId ? projectId : filter,
        projectName: filter === "all" ? "" : projects[filter].name,
        folderId: folderId ? folderId : "0",
    });

    const handleChange = (prop: string) => (event: any) => {
        setError("");
        if (prop !== 'projectName') {
            setValues({ ...values, [prop]: event.target.value });
            return;
        }
        const project: any = Object.values(currentProjects).find((project: any) => project.ID === event.target.value)
        project && setValues({ 
            ...values, 
            projectId: project.ID, 
            projectName: project.name

        });
    };

    const handleClose = () => {
        props.handleClose();
    };
    

    const DialogAction = () => {
        return (
            <>
                <Button
                    type="button"
                    color="primary"
                    variant="outlined"
                    fullWidth
                    sx={{
                        width: 85
                    }}
                    onClick={(e) => {
                        handleClose();
                    }}
                    aria-label="Cancel"
                    title="Cancel"
                >
                    CANCEL
                </Button> 
                <Button
                    color="primary"
                    variant="contained"
                    fullWidth
                    sx={{
                        width: 85,
                        '&.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.disabled,
                            opacity: '.75'
                        },
                    }}
                    onClick={(e) => {
                        addView();
                    }}
                    disabled={!(values.name.trim() && values.projectName.trim())}
                >
                    NEXT
                </Button>
            </>
        )
    }

    const addView = () => {
        const { name, description, projectId, folderId } = values;
        console.log("project:", projectId);
        if (name === "") {
            setError("name");
            return;
        }

        if (projectId === "all") {
            setError("project");
            return;
        }

        ViewsActions.createView(name, description, projectId, folderId, (viewId: string) => {
            if (history) {
                history.push("/views/" + viewId);
                history.goForward();
                handleClose();
            }
        });
    };
  
    const ProjectsData = useMemo(() => {
      const data = Object.values(currentProjects).map((project: any) => {
        const { name:label, ID:value} = project;
        return {
          label,
          value
        }
      });

      return data;
    }, [currentProjects]);

    return (
        <div>
            <CommonDialogBox
                classes={{
                    paper: `${classes.m24} ${classes.rounded8} ${classes.whitebg}`
                }}
                open={true}
                handleClose={handleClose}
                subtitle1="New View"
                actionClasses={`${classes.gap12}`}
                dialogAction={<DialogAction />}
                helpLinkCode="create-view"
            >
                <Stack 
                    gap={4}
                    direction="column"
                >
                    <div className={classes.row}>
                        <TextField
                            id="new-view-name"
                            label="View Name"
                            placeholder="Name"
                            onChange={handleChange("name")}
                            value={values.name}
                            error={error === "name"}
                            variant="outlined"
                            fullWidth
                        />
                    </div>
                    <div className={`${classes.row} textarea`}>
                        <TextField
                            id="new-view-description"
                            label="Description"
                            placeholder="Description"
                            onChange={handleChange("description")}
                            variant="outlined"
                            value={values.description}
                            maxRows={5}
                            fullWidth
                            multiline
                        />
                    </div>
                    <div className={classes.row}>
                        <FormControl error={error === "project"} style={{width: '100%'}}>
                            <FieldInputSelect2 
                                name="projectName" 
                                options={ProjectsData}
                                value={values.projectId}
                                label="Project" 
                                changeHandler={handleChange('projectName')}
                            />
                        </FormControl>
                    </div>
                </Stack>
            </CommonDialogBox>
        </div>
    );
}
